/* ============================================================
   ATYPIKA — produkční JS
   dither pole · skicář scatter engine · AJAX košík + šuplík · gramáže
   ============================================================ */
(function(){
'use strict';

function $(s,c){return (c||document).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

/* ---------- seeded PRNG (mulberry32) ---------- */
function rng(seed){
  var a=seed>>>0;
  return function(){
    a|=0;a=a+0x6D2B79F5|0;
    var t=Math.imul(a^a>>>15,1|a);
    t=t+Math.imul(t^t>>>7,61|t)^t;
    return((t^t>>>14)>>>0)/4294967296;
  };
}

/* ============ dither pole (fixní pozadí — náhodná kompozice vln, tvary se přelévají) ============ */
(function(){
  var c=document.getElementById('dither');
  if(!c)return;
  var x=c.getContext('2d');
  var gain=parseInt(c.getAttribute('data-gain'),10);if(isNaN(gain))gain=55;   /* pozor: 0 je platná hodnota (vypnutý rastr) */
  var anim=c.getAttribute('data-anim')==='1';
  var W,H,DPR,GRID=14,raf=null,last=0;
  /* TERMO — pole se pod kurzorem barví jako z termokamery a chladne (Theme settings -> Vzhled) */
  var termo=c.getAttribute('data-termo')||'';
  var TPAL=({ironbow:['#00000A','#20006E','#8E00A8','#EA3C00','#FFB300','#FFF3C8'],
    zar:['#0A0A0A','#5A0000','#B71C00','#FF6D00','#FFD54F'],
    led:['#0A0A0A','#0000FF','#3D8BFF','#9CC8FF','#EAF4FF'],
    duha:['#000080','#0000FF','#00B3B3','#00C853','#FFD600','#FF6D00','#D50000']})[c.getAttribute('data-tpal')]||
    ['#00000A','#20006E','#8E00A8','#EA3C00','#FFB300','#FFF3C8'];
  var TR=parseInt(c.getAttribute('data-tr'),10)||200;
  var TCH=parseInt(c.getAttribute('data-tch'),10)||8;
  var TMOB=c.getAttribute('data-tmob')||'bludicky';   /* chování na dotyku: bludicky | prst | vypnuto */
  var TOUCHY=window.matchMedia&&window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var HEAT=null,hcols=0,hrows=0,mxp=-1,myp=-1,fogEl=null,fogx=null,LUT=null;
  function hex3(cc){return [parseInt(cc.slice(1,3),16),parseInt(cc.slice(3,5),16),parseInt(cc.slice(5,7),16)]}
  function palRGB(tv){
    var pp=Math.max(0,Math.min(.999,tv))*(TPAL.length-1),kk=Math.floor(pp),f=pp-kk;
    var a=hex3(TPAL[kk]),b=hex3(TPAL[kk+1]);
    return [Math.round(a[0]+(b[0]-a[0])*f),Math.round(a[1]+(b[1]-a[1])*f),Math.round(a[2]+(b[2]-a[2])*f)];
  }
  function lut(){ /* paleta předpočítaná do 256 kroků — bez parsování hex per pixel */
    if(LUT)return LUT;LUT=new Uint8ClampedArray(256*3);
    for(var n=0;n<256;n++){var rgb=palRGB(n/255);LUT[n*3]=rgb[0];LUT[n*3+1]=rgb[1];LUT[n*3+2]=rgb[2];}
    return LUT;
  }
  /* bilineární vzorek teplotního pole v souřadnicích mřížky */
  function heatAt(u,v,cols,rows){
    var i0=Math.floor(u),j0=Math.floor(v);
    if(i0<0)i0=0;if(j0<0)j0=0;if(i0>cols-1)i0=cols-1;if(j0>rows-1)j0=rows-1;
    var fu=u-i0,fv=v-j0,st=rows+1;
    var a=HEAT[i0*st+j0],b=HEAT[(i0+1)*st+j0],c2=HEAT[i0*st+j0+1],d=HEAT[(i0+1)*st+j0+1];
    return (a*(1-fu)+b*fu)*(1-fv)+(c2*(1-fu)+d*fu)*fv;
  }
  function fogDraw(cols,rows,ox,oy){
    if(!HEAT||hcols!==cols||hrows!==rows){hcols=cols;hrows=rows;HEAT=new Float32Array((cols+1)*(rows+1));}
    var dec=1-(TCH/300),q;
    for(q=0;q<HEAT.length;q++)HEAT[q]*=dec;
    function inj(pxp,pyp,rpx,amt){
      var rc=Math.max(1,rpx/GRID),ci=(pxp-ox)/GRID,cj=(pyp-oy)/GRID;
      var i0=Math.max(0,Math.floor(ci-rc)),i1=Math.min(cols,Math.ceil(ci+rc));
      var j0=Math.max(0,Math.floor(cj-rc)),j1=Math.min(rows,Math.ceil(cj+rc));
      for(var i=i0;i<=i1;i++)for(var j=j0;j<=j1;j++){
        var dx=i-ci,dy=j-cj,dd=(dx*dx+dy*dy)/(rc*rc);
        if(dd>1)continue;
        var q2=i*(rows+1)+j;
        HEAT[q2]=Math.min(1.15,HEAT[q2]+amt*Math.exp(-dd*3));
      }
    }
    if(mxp>=0)inj(mxp,myp,TR,.5);
    if(TOUCHY&&TMOB==='bludicky'){
      /* dotyk: dvě toulavé žhavé stopy místo prstu (swipe za kartami vypadal divně) */
      var now=performance.now()/1000,k;
      for(k=0;k<2;k++){
        var bx=W*(.5+.36*Math.sin(now*.11+k*2.7)+.12*Math.sin(now*.23+k*1.1));
        var by=H*(.5+.33*Math.sin(now*.14+1.3+k*1.9)+.10*Math.cos(now*.19+k*3.1));
        inj(bx,by,TR*.85,.3);
      }
    }
    /* mlha má vlastní vrstvu pod rastrem: nízké rozlišení (půl buňky), roztažená přes CSS a rozostřená
       CSS filtrem — canvas.filter iOS Safari dlouho neuměl, proto byla mlha na mobilu kostičkovaná */
    if(!fogEl){
      fogEl=document.createElement('canvas');fogEl.id='termofog';fogEl.setAttribute('aria-hidden','true');
      fogEl.style.cssText='position:fixed;inset:0;width:100%;height:100%;z-index:0;pointer-events:none;filter:blur(14px);-webkit-filter:blur(14px);transform:translateZ(0)';
      c.parentNode.insertBefore(fogEl,c);fogx=fogEl.getContext('2d');
    }
    fogEl.style.opacity=c.style.opacity;
    var sub=2,fw=cols*sub+1,fh=rows*sub+1;
    if(fogEl.width!==fw||fogEl.height!==fh){fogEl.width=fw;fogEl.height=fh;}
    var mx=0;for(q=0;q<HEAT.length;q++)if(HEAT[q]>mx)mx=HEAT[q];
    if(mx<.02){fogx.clearRect(0,0,fw,fh);return;}
    var L=lut(),im=fogx.createImageData(fw,fh),dat=im.data,px,py;
    for(py=0;py<fh;py++)for(px=0;px<fw;px++){
      var hv=heatAt(px/sub,py/sub,cols,rows);if(hv<.02)continue;
      var n=Math.min(255,Math.round(Math.min(1,hv)*255)),o=(py*fw+px)*4;
      dat[o]=L[n*3];dat[o+1]=L[n*3+1];dat[o+2]=L[n*3+2];dat[o+3]=Math.min(255,Math.round(hv*235));
    }
    fogx.putImageData(im,0,0);
  }
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* při každé návštěvě jiná skladba: 3 vlny s náhodným směrem, délkou, rychlostí i fází —
     interference = velké organické tvary, které se pomalu přelévají (žádné zrno, žádné blikání) */
  var R=rng((Math.random()*4294967296)>>>0);
  var t=R()*200;
  var sy=window.scrollY||0,pend=false;   /* paralaxa: pole driftuje s rolováním (~18 % rychlosti) */
  var WAVES=[],AMP=0,k;
  for(k=0;k<3;k++){
    var ang=R()*Math.PI*2;
    var freq=(k===0?.035:.06)+R()*(k===0?.03:.09);
    var wv={kx:Math.cos(ang)*freq,ky:Math.sin(ang)*freq,
      w:(.3+R()*.5)*(R()<.5?-1:1),a:(k===0?1:.45+R()*.4),p:R()*Math.PI*2};
    WAVES.push(wv);AMP+=wv.a;
  }
  function resize(){
    DPR=Math.min(window.devicePixelRatio||1,2);
    W=window.innerWidth;H=window.innerHeight;
    c.width=Math.round(W*DPR);c.height=Math.round(H*DPR);
    x.setTransform(DPR,0,0,DPR,0,0);
  }
  var INK=(getComputedStyle(document.documentElement).getPropertyValue('--blue')||'').trim()||'#0000FF'; /* barva značky z CSS (modrá / černá) */
  function frame(){
    x.clearRect(0,0,W,H);
    if(gain<=0&&termo!=='plynule')return;
    var g=gain/55;
    c.style.opacity=String(Math.min(1,.35+.6*(Math.max(gain,termo==='plynule'?40:0)/100)));
    x.fillStyle=INK;x.strokeStyle=INK;x.lineWidth=1;
    x.font='10px "Space Mono",monospace';x.textAlign='center';x.textBaseline='middle';
    var cols=Math.floor(W/GRID),rows=Math.floor(H/GRID);
    var ox=(W-cols*GRID)/2,oy=(H-rows*GRID)/2,i,j;
    if(termo==='plynule')fogDraw(cols,rows,ox,oy); /* mlha pod rastrem */
    if(gain<=0)return; /* rastr vypnutý — jen mlha */
    x.fillStyle=INK;x.strokeStyle=INK;
    var cx=cols/2,cy=rows/2,md=Math.max(cols,rows)/1.5;
    var so=sy*.18/GRID;
    for(i=0;i<=cols;i++){
      for(j=0;j<=rows;j++){
        var px=ox+i*GRID+GRID/2,py=oy+j*GRID+GRID/2;
        var n=0;
        for(k=0;k<3;k++){var wv2=WAVES[k];n+=wv2.a*Math.sin(wv2.kx*i+wv2.ky*(j+so)+wv2.w*t+wv2.p);}
        var d=Math.sqrt((i-cx)*(i-cx)+(j-cy)*(j-cy));
        var v=((n/AMP)*.72+.5)*(1-(d/md)*.5)*g;
        var idx=Math.floor(v*6);
        if(idx<=0)continue;
        if(idx>5)idx=5;
        if(idx===1){x.fillText('.',px,py);}
        else if(idx===2){x.fillText('+',px,py);}
        else if(idx===3){x.strokeRect(px-3,py-3,6,6);}
        else if(idx===4){x.fillRect(px-2,py-2,4,4);}
        else{x.fillRect(px-3.5,py-3.5,7,7);}
      }
    }
  }
  function loop(ts){
    raf=requestAnimationFrame(loop);
    if(ts-last<33)return;
    last=ts;if(anim)t+=.012;frame();
  }
  function start(){
    if(reduce||document.hidden)return;
    if((!anim||gain<=0)&&termo!=='plynule')return;
    if(!raf){last=0;raf=requestAnimationFrame(loop);}
  }
  function stop(){if(raf){cancelAnimationFrame(raf);raf=null;}}
  /* paused = po dobu tepelné vlny na stránce s heslem: ani synchronní překreslení z resize/scroll
     (Chrome na iOS při odjezdu klávesnice a lišty sype resize události — každá = celý snímek mlhy = trhání) */
  var paused=false;
  window.addEventListener('resize',function(){if(paused)return;resize();frame();});
  if(termo==='plynule'&&!reduce){
    window.addEventListener('mousemove',function(e){mxp=e.clientX;myp=e.clientY;});
    window.addEventListener('mouseout',function(e){if(!e.relatedTarget){mxp=-1;myp=-1;}});
    if(!TOUCHY||TMOB==='prst')window.addEventListener('touchmove',function(e){if(e.touches&&e.touches[0]){mxp=e.touches[0].clientX;myp=e.touches[0].clientY;}},{passive:true});
  }
  document.addEventListener('visibilitychange',function(){if(document.hidden){stop();}else{start();}});
  /* stránka s heslem si mlhu na dobu tepelné vlny vypne (dvě animace naráz na mobilu trhaly) */
  document.addEventListener('atypika:fog',function(e){if(e.detail==='pause'){paused=true;stop();}else{paused=false;resize();frame();start();}});
  if(!reduce){
    window.addEventListener('scroll',function(){
      if(paused)return;
      sy=window.scrollY||0;
      if(!pend){pend=true;requestAnimationFrame(function(){pend=false;frame();});}
    },{passive:true});
  }
  resize();frame();
  start();
})();

/* ============ skicář scatter engine (katalog) ============ */
function layoutCatalog(cat){
  var nodes=$$('.node',cat);
  if(!nodes.length)return;
  var stacked=window.innerWidth<=900;
  cat.classList.toggle('stacked',stacked);
  if(stacked){cat.style.height='';return;}

  var cfg={
    size:parseInt(cat.getAttribute('data-size'),10)||420,
    varr:parseInt(cat.getAttribute('data-varr'),10)||0,
    rand:parseInt(cat.getAttribute('data-rand'),10)||0,
    dens:parseInt(cat.getAttribute('data-dens'),10)||50,
    rot:parseFloat(cat.getAttribute('data-rot'))||0,
    over:cat.getAttribute('data-over')==='1',
    seed:parseInt(cat.getAttribute('data-seed'),10)||26181
  };
  var R=rng(cfg.seed);
  var W=cat.clientWidth;
  var G=Math.round(18+(100-cfg.dens)*1.1);
  /* plná šířka obsahu: počet sloupců z cílové velikosti karty, šířka karet dopočtená tak,
     aby plný řádek přesně vyplnil W — první karta na levém, poslední na pravém gutteru */
  var cols0=Math.max(1,Math.round((W+G)/(cfg.size+G)));
  var fillW=Math.max(180,Math.min(620,(W-(cols0-1)*G)/cols0));
  var i,widths=[],heights=[];
  for(i=0;i<nodes.length;i++){
    var dev=1+((R()*2-1)*(cfg.varr/100));
    nodes[i].style.setProperty('--bw',Math.round(fillW*dev)+'px');
  }
  for(i=0;i<nodes.length;i++){widths.push(nodes[i].offsetWidth);heights.push(nodes[i].offsetHeight);}

  /* symetrická mřížka: jedna mezera G vodorovně i svisle (z hustoty),
     řádky centrované; náhodnost a rotace jsou jen šum navrch (0 = přesná mřížka) */
  var cols=Math.min(cols0,nodes.length);

  var pos=[],rowY=40,idx=0;
  while(idx<nodes.length){
    var end=Math.min(idx+cols,nodes.length),j,rowW=0,rowH=0;
    for(j=idx;j<end;j++)rowW+=widths[j];
    rowW+=G*(end-idx-1);
    var x=Math.max(0,(W-rowW)/2);
    for(j=idx;j<end;j++){
      pos.push({x:x,y:rowY,w:widths[j],h:heights[j]});
      x+=widths[j]+G;
      rowH=Math.max(rowH,heights[j]);
    }
    rowY+=rowH+G;
    idx=end;
  }
  if(cfg.rand>0){
    var jx=(cfg.rand/100)*(W/cols)*0.42;
    var jy=(cfg.rand/100)*G*2.2;
    for(i=0;i<pos.length;i++){
      pos[i].x=Math.max(0,Math.min(W-pos[i].w,pos[i].x+(R()*2-1)*jx));
      pos[i].y=Math.max(0,pos[i].y+(R()*2-1)*jy);
    }
  }

  if(!cfg.over){
    var PAD=16,pass,a,b;
    for(pass=0;pass<14;pass++){
      var moved=false;
      for(a=0;a<pos.length;a++)for(b=a+1;b<pos.length;b++){
        var A=pos[a],B=pos[b];
        var overX=(A.x-PAD<B.x+B.w+PAD)&&(B.x-PAD<A.x+A.w+PAD);
        var overY=(A.y-PAD<B.y+B.h+PAD)&&(B.y-PAD<A.y+A.h+PAD);
        if(overX&&overY){
          var dx=(A.x+A.w/2)-(B.x+B.w/2);
          var dy=(A.y+A.h/2)-(B.y+B.h/2);
          var pushX=((A.w+B.w)/2+PAD)-Math.abs(dx);
          var pushY=((A.h+B.h)/2+PAD)-Math.abs(dy);
          if(pushX<pushY){var sx=(dx>=0?1:-1)*pushX/2;A.x+=sx;B.x-=sx;}
          else{var sy=(dy>=0?1:-1)*pushY/2;A.y+=sy;B.y-=sy;}
          A.x=Math.max(0,Math.min(W-A.w,A.x));
          B.x=Math.max(0,Math.min(W-B.w,B.x));
          if(A.y<0)A.y=0;if(B.y<0)B.y=0;
          moved=true;
        }
      }
      if(!moved)break;
    }
  }

  var bottom=0;
  var R2=rng(cfg.seed+7);
  for(i=0;i<nodes.length;i++){
    var el=nodes[i];
    el.style.left=Math.round(pos[i].x)+'px';
    el.style.top=Math.round(pos[i].y)+'px';
    el.style.setProperty('--rot',((R2()*2-1)*cfg.rot).toFixed(2)+'deg');
    el.style.zIndex=String(2+Math.floor(R2()*8));
    bottom=Math.max(bottom,pos[i].y+pos[i].h);
  }
  cat.style.height=Math.round(bottom+60)+'px';
}
function layoutAll(){$$('.catalog[data-scatter]').forEach(layoutCatalog)}
var rT=null;
window.addEventListener('resize',function(){if(rT)clearTimeout(rT);rT=setTimeout(layoutAll,120);});
if(document.fonts&&document.fonts.ready)document.fonts.ready.then(layoutAll);

/* ============ košík — šuplík přes Section Rendering API ============ */
/* kořen obchodu (u vícejazyčných obchodů např. "/en/") — nikdy natvrdo "/" */
function shopRoot(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';}
var drawerWrap=document.getElementById('CartDrawer');
function openDrawer(){var d=$('.drawer');if(!d)return;d.classList.add('open');d.setAttribute('aria-hidden','false');var s=$('#scrim');if(s)s.hidden=false;}
function closeDrawer(){var d=$('.drawer');if(!d)return;d.classList.remove('open');d.setAttribute('aria-hidden','true');var s=$('#scrim');if(s)s.hidden=true;}
function refreshDrawer(open){
  return fetch(shopRoot()+'?sections=cart-drawer')
    .then(function(r){return r.json()})
    .then(function(j){
      if(!drawerWrap||!j['cart-drawer'])return;
      var wasOpen=$('.drawer')&&$('.drawer').classList.contains('open');
      var tmp=document.createElement('div');
      tmp.innerHTML=j['cart-drawer'];
      var fresh=tmp.querySelector('#CartDrawer');
      if(fresh)drawerWrap.innerHTML=fresh.innerHTML;
      var inner=drawerWrap.querySelector('[data-count]');
      var n=inner?inner.getAttribute('data-count'):null;
      if(n!==null)$$('[data-cart-count]').forEach(function(el){el.textContent=n});
      if(open||wasOpen)openDrawer();
    });
}
document.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('[data-open-cart]')){e.preventDefault();refreshDrawer(true).catch(function(){window.location.href=shopRoot()+'cart'});}
  if(e.target.closest&&e.target.closest('[data-close-cart]'))closeDrawer();
  if(e.target.closest&&e.target.closest('#scrim'))closeDrawer();
  var rm=e.target.closest&&e.target.closest('[data-line-remove]');
  if(rm){
    e.preventDefault();
    var onCartPage=!!rm.closest('.cart-page');
    fetch(shopRoot()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:rm.getAttribute('data-line-remove'),quantity:0})})
      .then(function(r){if(!r.ok)throw new Error('change failed');if(onCartPage){window.location.reload();}else{return refreshDrawer(true);}})
      .catch(function(){window.location.href=shopRoot()+'cart'});
  }
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer()});

/* ---------- přidání do košíku ---------- */
function addToCart(variantId,btn){
  if(!variantId)return;
  if(btn){btn.disabled=true;btn.setAttribute('data-wait','1');}
  fetch(shopRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:parseInt(variantId,10),quantity:1})})
    .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
    .then(function(){return refreshDrawer(true)})
    .catch(function(){window.location.href=shopRoot()+'cart'})
    .finally(function(){if(btn){btn.disabled=false;btn.removeAttribute('data-wait');}});
}

/* rychlé přidání z karty */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-quick-add]');
  if(!b)return;
  e.preventDefault();
  addToCart(b.getAttribute('data-variant'),b);
});

/* gramáže — segmentový PÁS: radio -> cena + variant id */
document.addEventListener('change',function(e){
  var t=e.target;
  if(!t.matches||!t.matches('input[data-vw]'))return;
  var scope=t.closest('[data-product-scope]');
  if(!scope)return;
  var avail=t.getAttribute('data-vavail')==='1';
  var price=scope.querySelector('[data-price]');
  if(price&&t.getAttribute('data-vprice'))price.textContent=t.getAttribute('data-vprice');
  var qa=scope.querySelector('[data-quick-add]');
  if(qa){
    qa.setAttribute('data-variant',t.value);
    qa.disabled=!avail;
  }
  var idInput=scope.querySelector('input[name="id"]');
  if(idInput)idInput.value=t.value;
  var submit=scope.querySelector('[data-product-submit]');
  if(submit)submit.disabled=!avail;
  /* štítek SKLADEM drží krok s vybranou gramáží (karta, detail i hero — sdílí data-product-scope) */
  var stxt=avail?'SKLADEM':'VYPRODÁNO';
  var full=scope.querySelector('.stk-plny');
  if(full){full.classList.toggle('on',avail);full.classList.toggle('out',!avail);full.textContent=stxt;}
  var neutral=scope.querySelector('.stk-tag');
  if(neutral)neutral.textContent=stxt;
});

/* produktový formulář — AJAX místo přechodu do košíku */
document.addEventListener('submit',function(e){
  var f=e.target.closest&&e.target.closest('form[data-ajax-product]');
  if(!f)return;
  e.preventDefault();
  var id=f.querySelector('input[name="id"]');
  addToCart(id?id.value:null,f.querySelector('[data-product-submit]'));
});

/* košík (stránka) — steppery */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-qty-change]');
  if(!b)return;
  e.preventDefault();
  var line=parseInt(b.getAttribute('data-line'),10);
  var input=document.querySelector('input[data-qty-input="'+line+'"]');
  var q=Math.max(0,(parseInt(input&&input.value,10)||0)+parseInt(b.getAttribute('data-qty-change'),10));
  fetch(shopRoot()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({line:line,quantity:q})})
    .then(function(){window.location.reload()})
    .catch(function(){window.location.reload()});
});

/* ---------- vlna tepla při otevření mobilního menu (bílý pás -> barva značky) ----------
   Jedna organická plocha na canvasu: obrys = kruh × šum (4 harmonické s náhodnou fází a amplitudou per
   otevření, pomalu se vlní), za čelem ironbow pás ~40 vmax (52 prstenců, zahuštěné u čela), na hraně
   zrno (420 teček). Žádné vrstvení gradientů — jedno čelo. */
var WAVE=(function(){
  var raf=null,cv=null,ctx=null,navEl=null,units=[],marks=[],stats=null;
  var STOPS=[[255,243,200,0],[255,179,0,4],[234,60,0,9],[142,0,168,16],[32,0,110,26],[0,0,0,40]]; /* rgb + hloubka za čelem (vmax) */
  /* text menu se odhaluje gradientem průhlednosti přímo v písmu (background-clip:text) vzorkovaným po šířce
     položky z tvaru vlny — text se nerozděluje na spany (kerning zůstává, po doběhnutí žádný posun) */
  var SAMPLES=7;
  function prep(nav){
    units=[];
    var els=nav.querySelectorAll('[data-wave-text],a,button,[data-cart-count]'),i;
    for(i=0;i<els.length;i++){
      var e=els[i],r=e.getBoundingClientRect();
      if(!r.width)continue;
      var st=e.style;
      st.color='transparent';st.webkitTextFillColor='transparent';
      st.webkitBackgroundClip='text';st.backgroundClip='text';
      st.backgroundImage='linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,0))';
      units.push({el:e,x:r.left,w:r.width,y:r.top+r.height/2,last:''});
    }
  }
  function unprep(){
    for(var i=0;i<units.length;i++){var st=units[i].el.style;st.color='';st.webkitTextFillColor='';st.webkitBackgroundClip='';st.backgroundClip='';st.backgroundImage='';}
    for(var m=0;m<marks.length;m++){marks[m].el.style.color='';marks[m].el.style.transition='';}
    units=[];marks=[];navEl=null;
  }
  function stop(){if(raf){cancelAnimationFrame(raf);raf=null;}unprep();}
  function inkRGB(){
    var v=(getComputedStyle(document.documentElement).getPropertyValue('--blue')||'').trim()||'#000000';
    if(v.charAt(0)==='#'&&v.length===7)return [parseInt(v.slice(1,3),16),parseInt(v.slice(3,5),16),parseInt(v.slice(5,7),16)];
    return [0,0,0];
  }
  function run(panel,x0,y0,done){
    stop();
    if(!cv){cv=document.createElement('canvas');cv.className='hm-wave';cv.setAttribute('aria-hidden','true');ctx=cv.getContext('2d');}
    if(cv.parentNode!==panel)panel.insertBefore(cv,panel.firstChild);
    var W=window.innerWidth,H=window.innerHeight,DPR=Math.min(window.devicePixelRatio||1,2);
    /* když zařízení nestíhá (medián prvních 8 intervalů > 26 ms), kreslit dál v 1× místo 2× — stejné prstence,
       barvy i časování, čtvrtina pixelů (iPhone Chrome trhal, Safari ne) */
    var ivals=[],lastT=null,lowered=false;
    function setDPR(d){DPR=d;cv.width=Math.round(W*d);cv.height=Math.round(H*d);ctx.setTransform(d,0,0,d,0,0);}
    setDPR(DPR);
    stats={frames:0,ms:0,dpr:DPR,lowered:false,median:0};
    var INK=inkRGB(),inkCss='rgb('+INK[0]+','+INK[1]+','+INK[2]+')';
    STOPS[5]=[INK[0],INK[1],INK[2],40];
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){ctx.fillStyle=inkCss;ctx.fillRect(0,0,W,H);if(done)done();return;}
    var vmax=Math.max(W,H)/100,band=40*vmax;
    /* text menu: gradienty průhlednosti nastavit ještě před prvním snímkem (žádný blik před vlnou) */
    navEl=panel.querySelector('nav');
    if(navEl)prep(navEl);
    /* prvky pásu (značka, případně wordmark): barva inkoust -> bílá podle téže vlny
       (křížek zůstává na CSS časovači — sedí v místě dotyku) */
    var hdr=panel.parentNode,mels=hdr?hdr.querySelectorAll('.hm-znacka,.hm-word'):[],mi;
    marks=[];
    for(mi=0;mi<mels.length;mi++){
      var mr=mels[mi].getBoundingClientRect();
      if(!mr.width)continue;
      mels[mi].style.transition='none';mels[mi].style.color='rgb('+INK[0]+','+INK[1]+','+INK[2]+')';
      marks.push({el:mels[mi],x:mr.left+mr.width/2,y:mr.top+mr.height/2,o:-1});
    }
    var far=Math.max(Math.hypot(x0,y0),Math.hypot(W-x0,y0),Math.hypot(x0,H-y0),Math.hypot(W-x0,H-y0));
    var Rmax=far*1.4+band,D=2600,t0=null;
    var ph=[],am=[],fr=[3,5,8,13],base=[.15,.09,.05,.025],k;
    for(k=0;k<4;k++){ph.push(Math.random()*Math.PI*2);am.push(base[k]*(.7+Math.random()*.6));}
    var grain=[],g;for(g=0;g<420;g++)grain.push([Math.random()*Math.PI*2,Math.random(),Math.random()]);
    var N=140,RINGS=52;
    function noise(a,el){var n=1;for(var q=0;q<4;q++)n+=am[q]*Math.sin(fr[q]*a+ph[q]+el*(q%2?-1:1)*.00035*(q+1));return n;}
    function blob(R,depth,el,c2){
      var X=c2||ctx;X.beginPath();
      for(var i=0;i<=N;i++){var a=i/N*Math.PI*2,r=Math.max(0,R*noise(a,el)-depth);var x=x0+Math.cos(a)*r,y=y0+Math.sin(a)*r;if(i)X.lineTo(x,y);else X.moveTo(x,y);}
      X.closePath();
    }
    /* znak se začne objevovat 12 vmax za čelem a je plný 34 vmax za ním (= zóna indigo→černá) */
    function revealFrame(R,el){
      for(var m=0;m<marks.length;m++){
        var M=marks[m],ma=Math.atan2(M.y-y0,M.x-x0),md=(R*noise(ma,el)-Math.hypot(M.x-x0,M.y-y0))/vmax;
        var mo=Math.max(0,Math.min(1,(md-12)/22));
        if(Math.abs(mo-M.o)>.02||mo===1&&M.o!==1){
          M.o=mo;
          M.el.style.color='rgb('+Math.round(INK[0]+(255-INK[0])*mo)+','+Math.round(INK[1]+(255-INK[1])*mo)+','+Math.round(INK[2]+(255-INK[2])*mo)+')';
        }
      }
      for(var u=0;u<units.length;u++){
        var U=units[u],stops=[],k2;
        for(k2=0;k2<SAMPLES;k2++){
          var sx=U.x+U.w*k2/(SAMPLES-1),ang=Math.atan2(U.y-y0,sx-x0),dist=Math.hypot(sx-x0,U.y-y0);
          var d=(R*noise(ang,el)-dist)/vmax,a=Math.max(0,Math.min(1,(d-12)/22));
          stops.push('rgba(255,255,255,'+a.toFixed(2)+') '+Math.round(100*k2/(SAMPLES-1))+'%');
        }
        var gs=stops.join(',');
        if(gs!==U.last){U.last=gs;U.el.style.backgroundImage='linear-gradient(90deg,'+gs+')';}
      }
    }
    function colorAt(d){
      for(var s2=0;s2<STOPS.length-1;s2++){var A=STOPS[s2],B=STOPS[s2+1];
        if(d<=B[3]){var f=(d-A[3])/(B[3]-A[3]);return 'rgb('+Math.round(A[0]+(B[0]-A[0])*f)+','+Math.round(A[1]+(B[1]-A[1])*f)+','+Math.round(A[2]+(B[2]-A[2])*f)+')';}}
      return inkCss;
    }
    function frame(now){
      if(t0===null)t0=now;
      if(lastT!==null){
        if(ivals.length<8){ivals.push(now-lastT);
          if(ivals.length===8){var sv=ivals.slice().sort(function(a,b){return a-b;});stats.median=Math.round(sv[4]);if(sv[4]>26&&DPR>1){setDPR(1);lowered=true;stats.lowered=true;stats.dpr=1;}}}
      }
      lastT=now;stats.frames++;
      var el=now-t0,pr=Math.min(1,el/D),e=1-Math.pow(1-pr,1.6),R=e*Rmax;
      ctx.clearRect(0,0,W,H);
      /* prstence zahuštěné u čela (barva se tam mění nejrychleji), v hloubce řidší */
      for(var q=0;q<RINGS;q++){var d=40*Math.pow(q/(RINGS-1),1.5);ctx.fillStyle=colorAt(d);blob(R,d*vmax,el);ctx.fill();}
      /* zrno na čele: žhavé tečky rozhozené kolem hrany */
      for(g=0;g<grain.length;g++){
        var G=grain[g],a=G[0],rr=R*noise(a,el)+(G[1]*2-1)*vmax*3.5+(G[2]-.5)*9;
        if(rr<0)continue;
        ctx.globalAlpha=.3+G[1]*.6;ctx.fillStyle=G[1]<.5?'#FFB300':'#FFF3C8';
        var sz=1+G[2]*2.2;ctx.fillRect(x0+Math.cos(a)*rr,y0+Math.sin(a)*rr,sz,sz);
      }
      ctx.globalAlpha=1;
      revealFrame(R,el);
      if(pr<1)raf=requestAnimationFrame(frame);
      else{
        raf=null;ctx.fillStyle=inkCss;ctx.fillRect(0,0,W,H);
        stats.ms=Math.round(el);
        unprep(); /* vlna doběhla: sundat gradienty (text je celý na tmě), layout se nemění */
        if(done)done();
      }
    }
    raf=requestAnimationFrame(frame);
  }
  return {run:run,stop:stop,stats:function(){return stats;}};
})();

/* ---------- hamburger (hlavička MAXI, <=720 px) ---------- */
/* zákaz pinch-zoomu jen po dobu otevřeného fullscreen menu: iOS Safari ignoruje user-scalable z viewportu,
   ale respektuje preventDefault na gesturestart a na vícedotykovém touchmove (proto non-passive, a jen dočasně) */
function zoomed(){return !!(window.visualViewport&&window.visualViewport.scale>1.01);}
var NOZOOM=(function(){
  var on=false;
  /* když už je stránka přiblížená, pinch (zpět na 1x) projde */
  function gest(e){if(!zoomed())e.preventDefault();}
  function tm(e){if(e.touches&&e.touches.length>1&&!zoomed())e.preventDefault();}
  return {
    enable:function(){if(on)return;on=true;document.addEventListener('gesturestart',gest,{passive:false});document.addEventListener('touchmove',tm,{passive:false});},
    disable:function(){if(!on)return;on=false;document.removeEventListener('gesturestart',gest);document.removeEventListener('touchmove',tm);}
  };
})();
/* záchranná brzda: je-li stránka při otevírání menu přiblížená, vrátit měřítko na 1x
   (iOS Safari okamžitě respektuje dočasné maximum-scale=1 ve viewport meta; jinde no-op) */
function resetZoom(){
  if(!zoomed())return;
  var m=document.querySelector('meta[name="viewport"]');if(!m)return;
  var orig=m.getAttribute('content')||'width=device-width, initial-scale=1';
  m.setAttribute('content',orig+', maximum-scale=1');
  setTimeout(function(){m.setAttribute('content',orig);},300);
}
/* zámek scrollu stránky po dobu otevřeného fullscreen menu (pás zůstává v toku — nic neodskočí, jen se nedá scrollovat) */
var LOCK=(function(){
  var y=0,on=false;
  return {
    on:function(){if(on)return;on=true;y=window.scrollY||0;document.documentElement.classList.add('hm-lock');document.body.style.top=(-y)+'px';},
    off:function(){if(!on)return;on=false;document.documentElement.classList.remove('hm-lock');document.body.style.top='';window.scrollTo(0,y);}
  };
})();
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-burger]');
  if(!b)return;
  var h=b.closest('header'),p=h&&h.querySelector('[data-burger-panel]');
  var open=b.getAttribute('aria-expanded')==='true';
  var full=!!(p&&getComputedStyle(p).position==='fixed');
  b.setAttribute('aria-expanded',open?'false':'true');
  if(p)p.hidden=open;
  if(h)h.classList.toggle('hm-open',!open);
  if(full&&!open){resetZoom();NOZOOM.enable();LOCK.on();}else{NOZOOM.disable();LOCK.off();}
  if(h&&!open){
    /* střed tepelné vlny = místo tapnutí (klávesnice: střed tlačítka) */
    var r=b.getBoundingClientRect(),cx=e.clientX,cy=e.clientY;
    if(!cx&&!cy){cx=r.left+r.width/2;cy=r.top+r.height/2;}
    if(full&&h.classList.contains('hdr-inv'))WAVE.run(p,cx,cy);
  }
  if(open)WAVE.stop();
});

/* ---------- stránka s heslem: čekací listina → tepelná vlna → instagram ---------- */
/* Odeslání jde na pozadí přes fetch, mezitím od tlačítka vyjede stejná vlna jako u mobilního menu
   (WAVE.run do overlaye .pw-after, text na tmě odhaluje po řádcích). Stejná hygiena jako u menu: zavřít
   klávesnici, vrátit měřítko na 1x, zakázat pinch, zamknout scroll, vypnout termo mlhu — a vlnu spustit až
   po usazení viewportu (klávesnice na iOS odjíždí ~300 ms; vlna přes to vypadala trhaně).
   Úspěch = Shopify přesměruje na ?customer_posted=true. Když server e-mail odmítne, vlna se zruší a ukáže se
   hláška; captcha/síť → po doběhnutí vlny klasické odeslání (stav pak vykreslí server staticky). */
(function(){
  var f=document.querySelector('[data-pw-news]');if(!f)return;
  var after=f.querySelector('[data-pw-after]'),err=f.querySelector('[data-pw-news-err]'),btn=f.querySelector('button[type="submit"]');
  if(!after||!btn)return;
  var px=0,py=0,pt=0,busy=false;
  btn.addEventListener('pointerdown',function(e){px=e.clientX;py=e.clientY;pt=Date.now();});
  function fog(st){try{document.dispatchEvent(new CustomEvent('atypika:fog',{detail:st}));}catch(e){}}
  /* počkat, až se viewport přestane měnit (odjíždějící klávesnice); bez klávesnice hned */
  function settle(kb,cb){
    var vv=window.visualViewport,done=false,quiet=null,hard=null;
    function fin(){if(done)return;done=true;if(vv)vv.removeEventListener('resize',bump);window.removeEventListener('resize',bump);clearTimeout(quiet);clearTimeout(hard);cb();}
    function bump(){clearTimeout(quiet);quiet=setTimeout(fin,120);}
    if(!kb){cb();return;}
    if(vv)vv.addEventListener('resize',bump);
    window.addEventListener('resize',bump);
    quiet=setTimeout(fin,180);hard=setTimeout(fin,700);
  }
  function restore(){WAVE.stop();after.hidden=true;LOCK.off();NOZOOM.disable();fog('resume');busy=false;}
  f.addEventListener('submit',function(e){
    if(busy||!window.fetch||!window.FormData)return;          /* bez fetch: klasické odeslání */
    if(f.checkValidity&&!f.checkValidity())return;             /* nativní hláška prohlížeče */
    e.preventDefault();busy=true;
    if(err)err.hidden=true;
    var r=btn.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2;
    if(Date.now()-pt<1500&&(px||py)){cx=px;cy=py;}                /* střed vlny = místo stisku, klávesnice: střed tlačítka */
    var ae=document.activeElement,kb=!!(ae&&ae.tagName==='INPUT'&&window.matchMedia&&window.matchMedia('(pointer:coarse)').matches);
    if(ae&&ae.blur&&ae!==document.body)ae.blur();
    resetZoom();NOZOOM.enable();fog('pause');
    var t1=Date.now(),t1s=t1,D=2600,state=null,started=false;
    function start(){
      if(started||state==='bad')return;started=true;
      LOCK.on();after.hidden=false;
      var rb=btn.getBoundingClientRect();
      if(!(Date.now()-pt<2500&&(px||py))){cx=rb.left+rb.width/2;cy=rb.top+rb.height/2;}   /* po odjezdu klávesnice se tlačítko mohlo posunout */
      t1=Date.now();
      var tw=Date.now();
      WAVE.run(after,cx,cy,function(){
        var a=after.querySelector('a');if(a&&a.focus)a.focus({preventScroll:true});
        if(/[?&]debug=1/.test(location.search)){
          var st=WAVE.stats()||{},d=document.createElement('p');d.className='pw-dbg';
          d.textContent='vlna '+st.ms+' ms · '+st.frames+' snímků · '+(st.frames&&st.ms?Math.round(st.frames/(st.ms/1000)):0)+' fps · medián '+st.median+' ms · dpr '+st.dpr+(st.lowered?' (sníženo)':'')+' · start +'+(tw-t1s)+' ms · kb '+(kb?1:0)+' · '+window.innerWidth+'×'+window.innerHeight+' · '+(navigator.userAgent.match(/CriOS|FxiOS|Safari/)||[''])[0];
          after.appendChild(d);
        }
      });
    }
    settle(kb,start);
    fetch(f.getAttribute('action')||'/contact',{method:'POST',body:new FormData(f),credentials:'same-origin'}).then(function(res){
      var u=res.url||'';
      if(u.indexOf('customer_posted=true')>-1)return 'ok';
      if(!res.ok||/\/challenge/.test(u))return 'native';
      return res.text().then(function(h){return /aria-invalid="true" aria-describedby="pw-news-err"/.test(h)?'bad':'native';});
    }).catch(function(){return 'native';}).then(function(st){
      state=st;
      if(st==='ok')return;
      if(st==='bad'){
        restore();
        if(err)err.hidden=false;
        var i=f.querySelector('input[type="email"]');if(i){i.setAttribute('aria-invalid','true');i.focus();}
        return;
      }
      setTimeout(function(){busy=false;f.submit();},Math.max(0,D-(Date.now()-t1)));
    });
  });
})();

/* ---------- boot ---------- */
function boot(){layoutAll();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
else boot();
window.addEventListener('load',layoutAll);
})();
